import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  shareReplay,
  startWith,
  map,
  tap,
  filter,
  delay,
  takeUntil,
} from 'rxjs/operators';
import { ReplaySubject, combineLatest, Subject } from 'rxjs';

interface ChartData {
  labels: string[];
  data: {
    x: number;
    y: number;
  }[];
}

@Component({
  selector: 'ma-chart-block',
  templateUrl: './chart-block.component.html',
  styleUrls: ['./chart-block.component.scss'],
})
export class ChartBlockComponent implements OnDestroy {
  @Input() isLoading: boolean;
  @Input() label: string;
  @Input() showInterval: boolean;
  @Output() intervalChange = new EventEmitter<string>();
  @Output() periodChange = new EventEmitter<string>();

  chartData$ = new ReplaySubject<ChartData>();
  @Input() set chartData(chartData: ChartData) {
    this.chartData$.next(chartData);
  }

  interval = new FormControl('days');
  period = new FormControl('30');

  period$ = this.period.valueChanges.pipe(shareReplay(1), startWith('30'));

  interval$ = this.interval.valueChanges.pipe(
    shareReplay(1),
    startWith('days'),
  );

  slicedData$ = combineLatest([this.chartData$, this.period$]).pipe(
    filter(([chartData]) => !!chartData),
    map(([{ labels, data }, period]) => {
      return {
        labels: labels.slice(-period),
        data: data.slice(-period),
      };
    }),
  );

  onDestroy$ = new Subject();

  constructor() {
    this.interval$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((value) => {
          this.intervalChange.emit(value);
        }),
      )
      .subscribe();
    this.period$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((value) => {
          this.periodChange.emit(value);
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
